import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {PammNetworkViewId} from '../types'
import {Description, Header, Title} from './NetworkViewHeader.styled'

/** Shape of an entry in `assets/messages`, which is plain JS and so carries no types of its own. */
type Message = {i18nKey: string; defaults: string}

/** Title and description per view — the wording tells the viewer whose network they are looking at. */
const VIEW_HEADINGS: Record<PammNetworkViewId, {title: Message; description: Message}> = {
  master: {title: messages.pammViewMasterTitle, description: messages.pammViewMasterDescription},
  agent: {title: messages.pammViewAgentTitle, description: messages.pammViewAgentDescription},
}

type NetworkViewHeaderProps = {
  /** The view currently rendered below the header. */
  view: PammNetworkViewId
}

/**
 * Heading above the PAMM network that names the active perspective (PT-5717 / PT-5718).
 *
 * With the toggle in play the same page renders two structurally similar trees, and the scope
 * difference between them (whole network vs. own subtree) is not something the tree itself can
 * show. The heading is what makes it unambiguous.
 *
 * @param view - The active view; selects both the title and the explanatory line.
 */
export const NetworkViewHeader = ({view}: NetworkViewHeaderProps) => (
  <Header>
    <Title data-testid="pamm-view-title">
      <Trans {...VIEW_HEADINGS[view].title} />
    </Title>
    <Description>
      <Trans {...VIEW_HEADINGS[view].description} />
    </Description>
  </Header>
)
